import React, { useState } from "react";
import styles from "./OrderFulfillment.module.scss";
import { Container } from "reactstrap";
import DynamicCardRow from "../../../../components/AdminPortalComponents/DynamicCardRow/DynamicCardRow";
import DynamicSquaredFilterBar from "../../../../components/common/AdminCommonComponents/FilterBars/DynamicSquaredFilterBar/DynamicSquaredFilterBar";
import ShippingCarrierPerformance from "../../../../components/AdminPortalComponents/OrderManagement/OrderFulfillment/ShippingCarrierPerformance/ShippingCarrierPerformance";
import InventoryLevelsFulfillment from "../../../../components/AdminPortalComponents/OrderManagement/OrderFulfillment/InventoryLevelsFulfillment/InventoryLevelsFulfillment";

const orderFulfillmentData = [
    { title: "Orders to be Fulfilled", value: 0 },
    { title: "Orders in Transit", value: 0 },
    { title: "Delivered Orders", value: 0 },
    { title: "Returns Pending", value: 0 }
].map(item => ({
    ...item,
    title: item.title.toUpperCase()
}));

const tabsData = [
    { key: "1", label: "Inventory Levels for Fulfillment" },
    { key: "2", label: "Shipping Carrier Performance" },
];

const OrderFulfillment = () => {
    const [activeTab, setActiveTab] = useState(tabsData[0]?.key || "");

    return (
        <div className={styles.mainContainer}>
            <Container fluid className={styles.orderWrapper}>
                <h5 className={styles.mainHeading}>Order Fulfillment</h5>
                <div className={styles.cardRowWrapper}>
                    <DynamicCardRow cards={orderFulfillmentData} />
                </div>
            </Container>
            <Container fluid className={styles.filterTableWrapper}>
                <div className={styles.squareFilterBarWrapper}>
                    <DynamicSquaredFilterBar
                        tabs={tabsData}
                        activeTab={activeTab}
                        setActiveTab={setActiveTab}
                        barType="default"
                    />
                </div>

                {activeTab === "1" && <InventoryLevelsFulfillment />}
                {activeTab === "2" && <ShippingCarrierPerformance />}
            </Container>
        </div>
    );
};

export default OrderFulfillment;